import React from 'react'
import { Icon, Progress } from 'antd'

import {
  getPhaseStatus,
  getPhaseView,
  getStatusLabel,
  isPhaseSelectable
} from '../../utils'
import './ProgressPreview.scss'

const ProgressPreview = ({
  phaseSteps,
  currentPhase,
  expandedPhases,
  progressPercent,
  isFinalized,
  onPhaseSelect
}) => {
  return (
    <aside className="creative-direction-chat__preview">
      <section className="creative-direction-chat__preview-card">
        <div className="creative-direction-chat__preview-header">
          <Icon type="eye" />
          <div>
            <h3>Creative Guideline Preview</h3>
            <p>A live view of what is ready for the shot list.</p>
          </div>
        </div>

        <div className="creative-direction-chat__progress-row">
          <span>Overall Progress</span>
          <strong>{progressPercent}%</strong>
        </div>
        <Progress
          percent={progressPercent}
          strokeColor="#5057d5"
          trailColor="#e8edf5"
          size="small"
          showInfo={false}
        />

        <div className="creative-direction-chat__workflow-label">Workflow</div>
        <div className="creative-direction-chat__phase-status-list">
          {phaseSteps.map((step, index) => {
            const view = getPhaseView(step.key)
            const status = getPhaseStatus({
              phaseSteps,
              currentPhase,
              phase: step.key,
              isFinalized
            })
            const canSelect = isPhaseSelectable({
              phaseSteps,
              currentPhase,
              phase: step.key,
              isFinalized
            })
            const isSelected = Boolean(expandedPhases[step.key])

            return (
              <button
                type="button"
                className={`creative-direction-chat__phase-status creative-direction-chat__phase-status--${status}${
                  isSelected
                    ? ' creative-direction-chat__phase-status--selected'
                    : ''
                }`}
                disabled={!canSelect}
                key={step.key}
                onClick={() => canSelect && onPhaseSelect(step.key)}
              >
                <span className="creative-direction-chat__phase-number">
                  {index + 1}
                </span>
                <span>{view.shortLabel}</span>
                <strong>{getStatusLabel(status)}</strong>
              </button>
            )
          })}
        </div>
      </section>
    </aside>
  )
}

export default ProgressPreview
